import { Box, Button, CircularProgress, Stack, TextField, Typography } from "@mui/material";
import moment from "moment";
import { TFaturaNotificacao } from "../../../../../../../../types/api/financeiro/detalhar-fechamentos-conta-corrente";
import { useMemo, useState } from "react";
import { formatarTelefone } from "../../../../../../../../helpers/masks";
import { desformatarTelefone } from "../../../../../../../../helpers/unmask";
import { useMutation } from "react-query";
import axiosClient from "../../../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";

export default function NotificacaoFatura({
    notificacao,
    tipo,
    validacaoInicial,
    onClose
}: NotificacaoFaturaProps) {

    const defaultDestinatario = useMemo(() => {
        if (tipo === "WhatsApp") {
            return formatarTelefone(notificacao.destinatario)
        }
        return notificacao.destinatario
    }, [tipo, notificacao.destinatario])

    const [internDestinatario, setInternDestinatario] = useState(defaultDestinatario)


    const { mutate: reenviar, isLoading: isLoadingEnviar } = useMutation({
        mutationKey: "reenviar-notificacao",
        mutationFn: (id: number) =>
            axiosClient.post(`/reenviar-notificacao/${id}`, {
                destinatario: tipo === "WhatsApp" ? desformatarTelefone(internDestinatario) : internDestinatario,
            }),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Erro ao reenviar notificação!", { variant: "error" });
        },
        onSuccess: () => {
            enqueueSnackbar("Envio de notificação realizado!", { variant: "success" });
            onClose();
        },
    });
    return (
        <Stack spacing={2} mb={2}>
            <Typography variant="h6">Enviar fatura por {tipo}</Typography>
            <TextField
                fullWidth
                label={tipo}
                value={internDestinatario}
                disabled={notificacao.status === 'Erro' ? false : true}
                onChange={(e) => {
                    if (tipo === "WhatsApp") {
                        setInternDestinatario(formatarTelefone(e.target.value))
                    }
                    else {
                        setInternDestinatario(e.target.value)
                    }
                }}
            />
            {
                notificacao.status === 'Enviando' &&
                <Box p={2} sx={{ border: '1px solid #d37f02', borderRadius: 4, bgcolor: '#fff3e0', color: '#d37f02' }}>
                    <Typography variant="body1">Enviando fatura</Typography>
                </Box>
            }
            {
                notificacao.status === 'Erro' &&
                <Box p={2} sx={{ border: '1px solid #BF0000', borderRadius: 4, bgcolor: '##FFF7F7', color: '#BF0000' }}>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Box>
                            <Typography variant="body1">Erro ao enviar fatura por {tipo}</Typography>
                            <Typography variant="body1">{notificacao.status_detalhe}</Typography>
                        </Box>
                        <Button
                            variant="text"
                            color="primary"
                            size="small"
                            disabled={isLoadingEnviar}
                            onClick={() => reenviar(notificacao.id)}
                        >
                            {
                                isLoadingEnviar &&
                                <CircularProgress size={18} sx={{ mr: 1 }} />
                            }
                            Tentar novamente
                        </Button>
                    </Stack>
                </Box>
            }
            {
                notificacao.status === 'Enviado' &&
                <Box p={2} sx={{ border: '1px solid #1B5E20', borderRadius: 4, bgcolor: '#EDF5E8', color: '#1B5E20' }}>
                    <Typography variant="body1">{notificacao.status_detalhe} por {tipo}</Typography>
                    <Typography variant="body1">{moment(notificacao.updated_at).format('DD/MM/YYYY [às] HH:mm')}</Typography>
                </Box>
            }
            {validacaoInicial}
        </Stack>
    )
}

interface NotificacaoFaturaProps {
    notificacao: TFaturaNotificacao
    tipo: 'Email' | 'WhatsApp',
    validacaoInicial: JSX.Element | null | true,
    onClose: () => void
}
